import Mapbox from 'index.vue';
import { BaseLayer } from './baseLayer';
export class BaseRasterLayer extends BaseLayer
{
    constructor(mapboxInstance: InstanceType<typeof Mapbox>,slot: string)
    {
        super(mapboxInstance,slot);
    }

    private layers: any[] = [];

    public AddLayer(id: string,tileUrl : string, mapTilesZoomLevelsAvailable: number): any {
        this.mapboxInstance.map.addSource('raster-source-'+ id, {
            type: 'raster',
            tiles: [tileUrl],
            tileSize: 256,
            minzoom: 0,
            maxzoom: mapTilesZoomLevelsAvailable
        });
        this.mapboxInstance.map.addLayer({
            id: 'raster-layer-' + id,
            type: 'raster',
            slot: this.slot,
            source: 'raster-source-' + id,
            paint: {}
        });
        this.layers.push(id);
    }

    public RemoveAllLayers() {
        this.layers.forEach((id: any) => {
            this.mapboxInstance.map.removeLayer('raster-layer-' + id);
            this.mapboxInstance.map.removeSource('raster-source-' + id);
        });
        this.layers = [];
    }

    public Show() {
        this.layers.forEach((id: any) => {
            this.mapboxInstance.map.setLayoutProperty('raster-layer-' + id, 'visibility', 'visible');
        });
        
    }

    public Hide() {
        this.layers.forEach((id: any) => {
            this.mapboxInstance.map.setLayoutProperty('raster-layer-' + id, 'visibility', 'none');
        });

    }

}